import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AppVersionService {
  private version: string = '';

  constructor(private http: HttpClient) {}

  async getVersion(): Promise<string> {
    if (this.version) {
      return this.version;
    }

    try {
      const data = await lastValueFrom(
        this.http.get<{ version: string }>('/assets/version/version.json')
      );

      if (data && data.version) {
        this.version = data.version;
        return this.version;
      } else {
        throw new Error('Versão não encontrada no package.json');
      }
    } catch (error) {
      console.error('Erro ao obter a versão:', error);
      return 'Versão indisponível';
    }
  }
}